module.exports = {
  OUTCOME: 'OUTCOME',
  SUMMARY: 'SUMMARY',
};
